import { URL as _URL } from "../interfaces/layouts"

const getDownloadFile = (url: _URL) => {
    fetch(url).then(response => response.blob()).then(file => {
        let tempLink = URL.createObjectURL(file)
        let anchorTag = document.createElement('a')
        anchorTag.href = tempLink
        anchorTag.download = url.toString().replace(/^.*[\\\/]/, '')
        document.body.appendChild(anchorTag)
        console.log( url )
        anchorTag.click() 
        URL.revokeObjectURL(tempLink);
        anchorTag.remove();
    }).catch(() => {
        
    })
} 
export default getDownloadFile

export function getDownload( blobData: Blob, title: string) {
    let tempLink = URL.createObjectURL( blobData )
    let anchorTag = document.createElement( 'a' )
    anchorTag.href = tempLink
    anchorTag.download = title.toString().replace(/^.*[\\\/]/, '')
    document.body.appendChild(anchorTag)
    // console.log( blobData )
    anchorTag.click() 
    URL.revokeObjectURL(tempLink);
    anchorTag.remove();
}